import React, { useState, useEffect, useCallback } from 'react';
import { useClientNavigation } from '../hooks/useClientNavigation.mjs';
import axios from 'axios';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import update from 'immutability-helper';
import { styles } from '../styles/plataformas.mjs';
import { apiUrl, apiUrl3 } from '../api/client.mjs';

const ItemType = 'PLATAFORMA';

const DraggableItem = ({ plat, index, moveItem }) => {
    const [, drag] = useDrag(() => ({
        type: ItemType,
        item: { id: plat.id, index },
    }), [plat, index]);

    const [, drop] = useDrop({
        accept: ItemType,
        hover(item, monitor) {
            if (item.index !== index) {
                moveItem(item.index, index);
                item.index = index;
            }
        }
    });

    return (
        <tr ref={(node) => drag(drop(node))} style={styles.itemPlataforma}>
            <td style={{ cursor: 'move', wordWrap: 'break-word', maxWidth: '100%' }}>{plat.url}</td>
        </tr>
    );
};

const EditarPosicao = () => {
    const [plataformas, setPlataformas] = useState([]);
    const { navigateToClient } = useClientNavigation();

    useEffect(() => {
        const url = apiUrl('promocional')
        axios.get(url)
            .then(response => {
                const sortedPlataformas = response.data.sort((a, b) => a.ordem - b.ordem);
                setPlataformas(sortedPlataformas);
            })
            .catch(error => console.error('Falha ao carregar plataformas:', error));
    }, []);

    const moveItem = useCallback((dragIndex, hoverIndex) => {
        const dragItem = plataformas[dragIndex];
        setPlataformas(update(plataformas, {
            $splice: [
                [dragIndex, 1],
                [hoverIndex, 0, dragItem],
            ],
        }));
    }, [plataformas]);

    useEffect(() => {
        // Quando a ordem é atualizada, enviar para o servidor
        plataformas.forEach((plat, index) => {

            if (plat.ordem !== index) {
                const url = apiUrl3(plat.id)
                axios.put(url, { ...plat, ordem: index })
                    .catch(error => console.error('Falha ao atualizar ordem:', error));
            }
        });
    }, [plataformas]);

    return (
        <DndProvider backend={HTML5Backend}>
            <div style={styles.container}>
                <h2 style={styles.titulo}>Edite a posição das mensagens!</h2>
                <span style={styles.descricao}>Aqui, você poderá editar a posição de envio de suas mensagens de plataformas, podendo alterar sua ordem, clicando e arrastando para cima ou para baixo.</span>
                <button onClick={() => navigateToClient('/plataformas')} style={styles.botaoAdicionar}>Salvar Posição</button>
                <table>
                    <tbody>
                        {plataformas.map((plat, index) => (
                            <DraggableItem key={plat.id} plat={plat} index={index} moveItem={moveItem} />
                        ))}
                    </tbody>
                </table>
            </div>
        </DndProvider>
    );
};

export default EditarPosicao;
